import { Component, ChangeDetectionStrategy, Input, OnDestroy, AfterViewInit, inject, ViewChild, ElementRef, NgZone } from '@angular/core';
import { HomePageCategoryModel, Product } from '@shared/models';
import { WindowService } from '@shared/window';
import { Subscription } from 'rxjs';
import Swiper from 'swiper';
import { Autoplay, FreeMode, Pagination } from 'swiper/modules';
import { ButtonComponent } from '../button/button.component';
import { RouterLink } from '@angular/router';
import { ProductThumbnailComponent } from '../product-thumbnail/product-thumbnail.component';
import { LocalizePipe } from '../../../i18n/pipes/lozalize.pipe';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-products-showcase',
    templateUrl: './products-showcase.component.html',
    styleUrls: ['./products-showcase.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, RouterLink, ProductThumbnailComponent, LocalizePipe, TranslatePipe],
})
export class ProductsShowcaseComponent implements OnDestroy, AfterViewInit {
    private zone = inject(NgZone);
    private windowService = inject(WindowService);

    @Input() products!: Product[];
    @Input() category!: HomePageCategoryModel;
    @ViewChild('swiper') swiperRef!: ElementRef<HTMLDivElement>;
    @ViewChild('swiperPagination') swiperPaginationRef!: ElementRef<HTMLDivElement>;

    readonly isClient = this.windowService.isClient;

    private swiper?: Swiper;
    private subscriptions$ = new Subscription();

    ngAfterViewInit() {
        if (this.windowService.isBrowser) {
            this.initSwiper();
        }
    }

    ngOnDestroy(): void {
        this.swiper?.destroy();
        this.subscriptions$.unsubscribe();
    }

    private initSwiper() {
        this.zone.runOutsideAngular(() => {
            this.swiper = new Swiper(this.swiperRef.nativeElement, {
                modules: [Autoplay, FreeMode, Pagination],
                spaceBetween: 26,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                },
                freeMode: {
                    enabled: true,
                    sticky: true,
                    momentum: false,
                },
                speed: 1500,
                loop: true,
                shortSwipes: false,
                pagination: {
                    el: this.swiperPaginationRef.nativeElement,
                    type: 'bullets',
                },
                watchOverflow: true,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                breakpoints: {
                    0: {
                        slidesPerView: 'auto',
                    },
                    768: {
                        slidesPerView: 3,
                    },
                },
                threshold: 5,
            });
        });
    }
}
